import React, { useState } from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { createReceiptType } from '../../../usecases/receipts-usecase';
import ReceiptTypeForm from '../ReceiptTypeForm/view';

function CreateReceiptType() {
    const [resetKey, setResetKey] = useState(0);

    function handleSubmit(payload) {
        createReceiptType(payload).then(res => {
            dispatchCustomEvent("popup", { message: "Tipo de Recibo Creado" });
            dispatchCustomEvent("close-create-receipt-type-modal", {});
            dispatchCustomEvent("update-receipt-types", {});
            setResetKey(prev => prev + 1);
        }).catch(err => {
            if (err.status === 429) {
                dispatchCustomEvent("popup", { message: "Alcanzaste el limite" });
            } else {
                dispatchCustomEvent("popup", { message: err.response?.data?.message || "Error al crear tipo de recibo", type: "error" });
            }
            dispatchCustomEvent("loading-btn", {});
        });
    }

    return (
        <ModalBtn
            id="create-receipt-type"
            title="Crear Tipo de Recibo"
            style={{ width: '65vw', maxWidth: '95vw' }}
        >
            <ReceiptTypeForm
                key={resetKey}
                onSubmit={handleSubmit}
                loadingId="create-receipt-type-btn"
                title="Crear Tipo de Recibo"
                submitLabel="Crear Tipo de Recibo"
            />
        </ModalBtn>
    );
}

export default CreateReceiptType;
